import classNames from 'classnames'
import { HTMLAttributes } from 'react'
import { IconLoading } from '../icon-loading'
import styles from './index.module.css'

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export const Spinner = (props: Props) => {
  return (
    <div {...props} role="progressbar" className={classNames(styles.spinner, props.className)}>
      <IconLoading style={{ fontSize: '5em', marginBottom: '1em', color: 'var(--color-primary-500)' }} />
      {props.children}
    </div>
  )
}
